import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

type ClassFunction<T> = (values: T) => string;
type ClassValues<T> = Array<ClassValue | ClassFunction<T>>;

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Helper function to allow functions to be input to be calculated with react-aria-components
export function cnv<T>(values: T, ...inputs: ClassValues<T>) {
  const processedInputs = inputs.map(input => {
    if (typeof input === 'function') {
      return input(values);
    }

    return input;
  });

  return cn(processedInputs);
}

export function toSentenceCase(str: string) {
  return str
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .toLowerCase()
    .replace(/^\w/, c => c.toUpperCase())
    .replace(/\s+/g, ' ')
    .trim();
}
